export function translateTeamName(name, translate) {
    const normalizedName = String(name || "").trim();
    if (!normalizedName) return "";
    return translate(normalizedName) || normalizedName;
}

export function teamDisplayName(team, translate) {
    return translateTeamName(team?.name, translate);
}
